import React from 'react';
import styles from 'assets/css/BetaLabel.module.scss';

const BetaLabel = () => <span className={styles.label}>BETA</span>;

export default BetaLabel;
